document.addEventListener("turbo:render", () => {
  const video = document.getElementById('video-background');

  if (video) { video.play(); }
});
